import { render, staticRenderFns } from "./review-page.vue?vue&type=template&id=a9c92512&"
import script from "./review-page.vue?vue&type=script&lang=js&"
export * from "./review-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports